import { render, staticRenderFns } from "./SwiperProducts.vue?vue&type=template&id=1574f6a4&"
import script from "./SwiperProducts.vue?vue&type=script&lang=js&"
export * from "./SwiperProducts.vue?vue&type=script&lang=js&"
import style0 from "./SwiperProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports